import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbMenuItem } from '@nebular/theme';
import { ActionState, SelectedValue, UbsViewContainersModule, ViewContainersService } from '@urbannex/view-containers';
import { RouterModule, Routes } from '@angular/router';
import { ProductsComponent } from './products.component';
import { ProductComponent } from './product/product.component';
import { RemoteFormData } from '@urbannex/ofbiz-forms';

export const productroutes: Routes = [
  {
    path: '',
    component: ProductsComponent,
    /* children:[
      {
        path:'product/:productStoreId',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/prices',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/content',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/geos',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/ids',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/categories',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/keywords',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/associations',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/costs',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/attributes',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/features',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/facilities',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/locations',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/inventory',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/suppliers',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/agreements',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/accounts',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/payment-types',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/maintenance',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/meters',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/subscription-resource',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/quick-admin',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/vendors',
        component:ProductsComponent,
      },
      {
        path:'product/:productStoreId/work-efforts',
        component:ProductsComponent,
      }
    ] */
  },
  {
    path: 'product',
    component: ProductComponent
  },
  {
    path: 'product/:productId',
    component: ProductComponent
  },
  {
    path: 'product/:productId/categories/relate',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Categories",
    }
  },
  {
    path: 'product/:productId/keywords/:relate',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Keywords",
    }
  },
  {
    path: 'product/:productId/association',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Associations",
    }
  },
  {
    path: 'product/:productId/categories/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Categories",
    }
  },
  {
    path: 'product/:productId/features/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Features",
    }
  },
  {
    path: 'product/:productId/costs/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Costs",
    }
  },
  {
    path: 'product/:productId/attributes/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Attributes",
    }
  },
  {
    path: 'product/:productId/ids/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "IDs",
    }
  },
  {
    path: 'product/:productId/locations/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Locations",
    }
  },
  {
    path: 'product/:productId/geos/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Geos",
    }
  },
  {
    path: 'product/:productId/meters/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Meters",
    }
  },
  {
    path: 'product/:productId/suppliers/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Suppliers",
    }
  },
  {
    path: 'product/:productId/agreements/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Agreements",
    }
  },
  {
    path: 'product/:productId/vendor/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Vendor",
    }
  },
  {
    path: 'product/:productId/prices/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Prices",
    }
  },
  {
    path: 'product/:productId/orders/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Orders",
    }
  },
  {
    path: 'product/:productId/payments/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Payment Types",
    }
  },
  {
    path: 'product/:productId/accounts/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Accounts",
    }
  },
  {
    path: 'product/:productId/groupOrder/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Group Order",
    }
  },
  {
    path: 'product/:productId/facilities/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Facilities",
    }
  },
  {
    path: 'product/:productId/inventory/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Inventory",
    }
  },
  {
    path: 'product/:productId/maintenance/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Maintenance",
    }
  },
  {
    path: 'product/:productId/content?:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Content",
    }
  },
  {
    path: 'product/:productId/subscriptions/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Subscription Resources",
    }
  },
  {
    path: 'product/:productId/workEffort/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Work Efforts",
    }
  },
  {
    path: 'product/:productId/parties/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Parties",
    }
  },
  {
    path: 'product/:productId/communications/:event',
    component: ProductComponent,
    data: {
      event: ActionState.RELATE,
      type: "Communications",
    }
  }

]

export const listMenuData: SelectedValue = {
  event: "list",
  type: "ListProductCategoryMembers",
  data: {
    formData: {
      formName: "ListProductCategoryMembers",
      formLocation: "component://kwikstore/widget/ImageManagementForms.xml"
    },
    appContext: "catalog",

  }
}

const MENU_ITEMS: NbMenuItem[] = [
  {
    title: "List Products",
    icon: "list-outline",
    link: "/admin/products",
    data: listMenuData
  },
  {
    title: "New Product",
    icon: "plus-outline",
    link: "/admin/products/product",
    data: {
      event: ActionState.ADD
    }
  }
];
const headerTitle: string = "Product Information";
const path: string = "products";
const menuTag: string = "productsMenu"


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(productroutes),
    UbsViewContainersModule
  ]
})
export class ProductsRoutingModule {
  menuAndTitleOptions = { path: path, menuItems: MENU_ITEMS, headerTitle: headerTitle, menuTag: menuTag };

  constructor(private viewContainerService: ViewContainersService) {
    this.viewContainerService.menuAndTitleOptions$.next([... this.viewContainerService.menuAndTitleOptions$.getValue(), this.menuAndTitleOptions]);
    this.viewContainerService.activeMenuTag$.next(menuTag);
    // this.viewContainerService.addMenuAndTitleOptions(menuAndTitleOptions)
  }
}
